import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { renderFormMixins } from "@/mixins/renderFormMixins";
import { getUserInfo } from "@/api/user";
import config from "@/config";
import { add_table_data, edit_platform } from "@/api/chuku";
export default {
  name: "addAppCustom",
  mixins: [renderFormMixins],
  data: function data() {
    return {
      is_dingji: null,
      tableloading: false,
      reqBase: {},
      formModel: {
        type: 1,
        fileinfo: null,
        desc: null,
        merchant_name: null,
        filename: null,
        shop_name: null
      },
      imgUrl: null,
      refresh_valueData: [{
        name: "10" + this._vm.$t('秒'),
        value: 10
      }, {
        name: "15" + this._vm.$t('秒'),
        value: 15
      }, {
        name: "30" + this._vm.$t('秒'),
        value: 30
      }, {
        name: "1" + this._vm.$t('分钟'),
        value: 60
      }, {
        name: "5" + this._vm.$t('分钟'),
        value: 300
      }, {
        name: "10" + this._vm.$t('分钟'),
        value: 600
      }, {
        name: "15" + this._vm.$t('分钟'),
        value: 900
      }, {
        name: "30" + this._vm.$t('分钟'),
        value: 1800
      }, {
        name: "60" + this._vm.$t('分钟'),
        value: 3600
      }],
      spinShow: false,
      fileList: [],
      // 用于存储当前上传的文件
      formRules: {
        desc: [{
          required: true,
          type: "number",
          message: "频率不能为空",
          trigger: "change"
        }],
        filename: [{
          required: true,
          message: this._vm.$t('平台中文名不能为空'),
          trigger: "change"
        }],
        merchant_name: [{
          required: true,
          message: this._vm.$t('平台英文名不能为空'),
          trigger: "change"
        }],
        shop_name: [{
          required: true,
          message: this._vm.$t('代理商不能为空'),
          trigger: "change"
        }],
        fileinfo: [{
          required: true,
          // type: "object",
          message: this._vm.$t('请上传logo'),
          trigger: "change"
        }]
      }
    };
  },
  props: {
    _vm: {},
    edit: {
      type: Boolean,
      default: false
    },
    $store: {},
    setData: {},
    merchant_name: {},
    parent_name: {}
  },
  components: {},
  methods: {
    beforeUpload: function beforeUpload(file) {
      var _this = this;

      this.$refs["upload"].clearFiles();
      var formData = new FormData();

      if (file) {
        formData.append("fileinfo", file);
      } else {
        formData.append("fileinfo", this.formModel.fileinfo);
      }

      formData.append("type", 1);
      formData.append("desc", "1");
      formData.append("merchant_name", "1");
      formData.append("filename", "1");
      add_table_data(formData).then(function (res) {
        _this.formModel.fileinfo = res.body;
        _this.imgUrl = "".concat(process.env.NODE_ENV === "development" ? config.baseUrl.dev : process.env.VUE_APP_BUILD === "production" ? config.baseUrl.pro : config.baseUrl.alp).concat(res.body);
      });
      return false;
    },
    handleChange: function handleChange(file) {
      this.fileList = [file];
      this.formModel.fileinfo = file;
      this.$refs[refName].validateField("fileinfo");
    }
  },
  mounted: function mounted() {},
  created: function created() {
    var _this2 = this;

    var descValue = localStorage.getItem("shuaxin");
    this.formModel.desc = descValue ? Number(descValue) : null;
    getUserInfo().then(function (res) {
      console.log("个人信息", res.body, _this2.formModel.desc);
      _this2.is_dingji = res.body.is_dingji;
      _this2.formModel.filename = res.body.web_name[0].zh;
      _this2.formModel.merchant_name = res.body.web_name[0].en;
      _this2.formModel.fileinfo = res.body.logo_url;
      _this2.formModel.shop_name = res.body.shop_name;
      _this2.imgUrl = "".concat(process.env.NODE_ENV === "development" ? config.baseUrl.dev : process.env.VUE_APP_BUILD === "production" ? config.baseUrl.pro : config.baseUrl.alp).concat(res.body.logo_url);
    });
  }
};